import LocalizedMessage from '../common/LocalizedMessage';
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import NotificationService from "../../services/NotificationService";
import { useTranslation } from 'react-i18next';

const STATUS = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

function getToken(search) {
  return new URLSearchParams(search || "").get("token");
}

function LessonReminderUnsubscribe({ location }) {
  const { t: tr } = useTranslation();
  const [status, setStatus] = useState(STATUS.LOADING);
  const [message, setMessage] = useState(tr("public:disablingReminders_89"));

  useEffect(() => {
    const token = getToken(location.search);

    if (!token) {
      setStatus(STATUS.ERROR);
      setMessage(tr("public:theLinkIsInvalid_90"));
      return;
    }

    NotificationService.unsubscribeFromLessonReminders(token)
      .then(() => {
        setStatus(STATUS.SUCCESS);
        setMessage(tr("public:remindersHaveBeenDisabled_91"));
      })
      .catch(() => {
        setStatus(STATUS.ERROR);
        setMessage(tr("public:theLinkIsInvalid_90"));
      });
  }, [location.search]);

  return (
    <main className="quiz-text blurred-background">
      <div className="container-fluid">
        <div className="pt-2 row content">
          <div className="col-xl-2" />
          <div className="col-xl-8">
            <h2><strong><LocalizedMessage value={message} /></strong></h2>
            {status === STATUS.SUCCESS && (
              <p>{tr("public:weWillNotSendAnyFurtherLessonReminders_92")}</p>
            )}
            {status === STATUS.ERROR && (
              <div className="alert alert-danger" role="alert">{tr("public:weCannotDisableRemindersUsingThisLinkContactThe_93")}</div>
            )}
          </div>
          <div className="col-xl-2" />
        </div>
      </div>
    </main>
  );
}

LessonReminderUnsubscribe.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default LessonReminderUnsubscribe;
